import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import GlobalStyles from './styles/GlobalStyles';

// Import pages
import Home from './pages/Home/Home';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Fixtures from './pages/Fixtures/Fixtures';
import Results from './pages/Results/Results';
import PlayerStats from './pages/PlayerStats/PlayerStats';
import PlayerProfile from './pages/PlayerProfile/PlayerProfile';
import Shop from './pages/Shop/Shop';
import Error from './pages/Error/Error';
import Sponsors  from './pages/Sponosrs/Sponsors';

const App: React.FC = () => {
  return (
    <Router>
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/sponsors" element={<Layout><Sponsors /></Layout>} />
        <Route path="/fixtures" element={<Layout><Fixtures /></Layout>} />
        <Route path="/results" element={<Layout><Results /></Layout>} />
        <Route path="/player-stats" element={<Layout><PlayerStats /></Layout>} />
        <Route path="/player/:playerName" element={<Layout><PlayerProfile /></Layout>} />
        <Route path="/shop" element={<Layout><Shop /></Layout>} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
};

export default App;
